module.exports = __webpack_public_path__ + "img/4.3700c45f.png";